'use client';

import { useClientTranslation } from '@lib/i18n/client';
import { Tag } from '@tuic/web-compositions/core/Tag';

import type PrismAPI from '@modules/prism-client/types/prism-types';
import type { Locale } from '@tuic/i18n';
import type { FC, ReactNode } from 'react';

interface NewInformationTagProps {
  newInformationTag: PrismAPI.CardNewInformationTag;
  originalTag?: ReactNode;
  locale: Locale;
}

export const NewInformationTag: FC<NewInformationTagProps> = ({
  newInformationTag,
  originalTag,
  locale,
}) => {
  const { t } = useClientTranslation(locale);

  // No new information: render original tag (availability/discount)
  if (newInformationTag.showTag === false) {
    return originalTag;
  }

  // Account user: Server determined if tag should show
  if (newInformationTag.showTag === true) {
    return <Tag variant="white">{t('Neue Informationen')}</Tag>;
  }

  // Booking code user: Check localStorage against updatedAt
  const lastVisit = localStorage.getItem('dailyNewsLastVisitedAt');

  const shouldShow =
    !lastVisit || new Date(newInformationTag.updatedAt) > new Date(lastVisit);

  if (shouldShow) {
    return <Tag variant="white">{t('Neue Informationen')}</Tag>;
  }

  return originalTag;
};
